import React, { useState } from 'react';
import bgImage from '../assets/bk.jpg'; // same background image as Signup
import { useNavigate } from 'react-router-dom';
import { Container, Form, Button, Card } from 'react-bootstrap';

function Login({ setUser }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    const users = JSON.parse(localStorage.getItem('users') || '[]');
    const user = users.find(u => u.email === email && u.password === password);
    if (user) {
      setUser(user);
      localStorage.setItem('currentUser', JSON.stringify(user));
      navigate('/main');
    } else {
      alert('Invalid credentials');
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px'
      }}
    >
      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <Card
          style={{
            width: '100%',
            maxWidth: '420px',
            borderRadius: '15px',
            padding: '20px',
            background: 'rgba(255, 255, 255, 0.15)',
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            color: 'white',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            boxShadow: '0 8px 20px rgba(0,0,0,0.3)'
          }}
        >
          <Card.Body>
            <h2 className="text-center mb-4" style={{ color: '#fff' }}>
              Login
            </h2>
            <Form onSubmit={handleLogin}>
              <Form.Group className="mb-3">
                <Form.Label style={{ color: '#fff' }}>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  style={{
                    borderRadius: '8px',
                    padding: '10px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    color: '#000'
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label style={{ color: '#fff' }}>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  style={{
                    borderRadius: '8px',
                    padding: '10px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    color: '#000'
                  }}
                />
              </Form.Group>

              <Button
                type="submit"
                variant="primary"
                className="w-100"
                style={{ borderRadius: '8px', padding: '10px' }}
              >
                Login
              </Button>
              <Button
                variant="link"
                className="w-100 mt-2"
                onClick={() => navigate('/signup')}
                style={{ color: '#ddd', textDecoration: 'underline' }}
              >
                Don't have an account? Sign Up
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}

export default Login;
